import { render, staticRenderFns } from "./VendorCreate.vue?vue&type=template&id=245556da&scoped=true&"
import script from "./VendorCreate.vue?vue&type=script&lang=js&"
export * from "./VendorCreate.vue?vue&type=script&lang=js&"
import style0 from "./VendorCreate.vue?vue&type=style&index=0&id=245556da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245556da",
  null
  
)

export default component.exports